export class SetJobLevels {
    static readonly type = '[JobLevel] set';
    constructor(public data: any[]) { }
}
